export const CHANGE_ACTIVE_NAV = "CHANGE_ACTIVE_NAV";
export const CHANGE_ACTIVE_SCHOOL = "CHANGE_ACTIVE_SCHOOL";
export const REHYDRATE_NAV_DATA = "REHYDRATE_NAV_DATA";
export const CHANGE_SELECTED_ROUTE = "CHANGE_SELECTED_ROUTE";
export const CHANGE_SELECTED_ADDRESS_FROM_MARKER =
  "CHANGE_SELECTED_ADDRESS_FROM_MARKER";
export const UPDATE_ROUTE_TIME_DATA = "UPDATE_ROUTE_TIME_DATA";
export const IS_FINISH_FETCH_OPTIMISATION_ROUTE =
  "IS_FINISH_FETCH_OPTIMISATION_ROUTE";
